import { render } from "./AuthLayout.vue?vue&type=template&id=5063716f"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=5063716f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__